
import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

import BoxChartComponent from "./chart.box";
import CloudChartComponent from "./chart.cloud";
import DemoChartComponent from "./chart.demo";

export default class Web extends mixin(environment.nexus, {
  box: BoxChartComponent,
  cloud: CloudChartComponent,
  demo: DemoChartComponent,
}) { }
